import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';

const ResponsiveTableWrapper = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box 
      sx={{
        width: '100%',
        overflowX: isMobile ? 'auto' : 'visible',
        maxWidth: '100%',
        '& table': {
          width: '100%',
        },
        '& .MuiTableCell-root': {
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
          padding: { xs: '8px', sm: '16px' },
          whiteSpace: isMobile ? 'nowrap' : 'normal',
        },
        '& .MuiTableHead-root .MuiTableCell-root': {
          fontWeight: 600,
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
        },
        // Hide some columns on very small screens
        '& .hide-mobile': {
          display: { xs: 'none', md: 'table-cell' },
        },
        // Adjust button sizes
        '& .MuiButton-root': {
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
          padding: { xs: '4px 8px', sm: '6px 16px' },
        },
        '& .MuiIconButton-root': {
          padding: { xs: '4px', sm: '8px' },
        },
      }}
    >
      {children}
    </Box>
  );
};

export default ResponsiveTableWrapper;